import React, { HTMLAttributes, MouseEvent, FC } from 'react';

import { ClassNameBuilder } from '../../utils/ClassNameBuilder';
import { Icon } from '../Icon/Icon';

import Styles from './IconButton.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  image: string;
  className?: string;
  title?: string;
  dataId?: string;
  onClick?: (event: MouseEvent) => void;
}

export const IconButton: FC<Props> = ({
  className,
  image,
  dataId,
  onClick,
  title,
  ...rest
}: Props) => {
  const containerClass = new ClassNameBuilder(Styles, 'container').add(className).toString();

  return (
    <div className={containerClass} onClick={onClick} data-id={dataId} {...rest}>
      <div className={Styles.image}>
        <Icon src={image} title={title} />
      </div>
    </div>
  );
};
